import {clsx, type ClassValue} from 'clsx';
import {twMerge} from 'tailwind-merge';

/** Merge Tailwind classes so a later class always wins over an earlier conflicting one. */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
